import store from "@/store"

export const isUseFeature = (feature) => {
  return store.getters['auth/features'].includes(feature)
} 